import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
const CoordinateSelection = () => {
  const { id } = useParams();
//   useEffect(() => {});
  return <div>CoordinateSelection</div>;
};

export default CoordinateSelection;
